import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { Dispatch } from 'redux';
import { FilterParams, ObjectWithId, Topic } from '@synergy/models';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';

import { Api } from '../../../../../api';
import { AppState } from '../../../../../store/models/app-state';
import { TopicRequest } from '../../../../../common/api/models/topic-request';

export const TOPICS_REQUEST = 'TOPICS_REQUEST';
export const AVAILABLE_TOPICS_FOR_CUSTOMER_REQUEST = 'AVAILABLE_TOPICS_FOR_CUSTOMER_REQUEST';
export const TOPICS_RECEIVED = 'TOPICS_RECEIVED';
export const AVAILABLE_TOPICS_FOR_CUSTOMER_RECEIVED = 'AVAILABLE_TOPICS_FOR_CUSTOMER_RECEIVED';
export const TOPIC_DETAIL_RECEIVED = 'TOPIC_DETAIL_RECEIVED';
export const TOPIC_DETAIL_CLEAR = 'TOPIC_DETAIL_CLEAR';
export const TOPIC_DELETED = 'TOPIC_DELETED';
export const TOPICS_FAILED = 'TOPICS_FAILED';

export const clearTopicDetail = () => ({ type: TOPIC_DETAIL_CLEAR });

export const fetchTopics = (searchParams?: URLSearchParams) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: TOPICS_REQUEST });

        const response = await api.topics.cget(searchParams);

        if (response.success) {
            dispatch({ type: TOPICS_RECEIVED, topics: response.result });
        } else {
            dispatch({ type: TOPICS_FAILED });
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const fetchAllTopics = () => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: TOPICS_REQUEST });

        const searchParams = new URLSearchParams({ [FilterParams.PageSize]: '10000' });
        const response = await api.topics.cget(searchParams);

        if (response.success) {
            dispatch({ type: TOPICS_RECEIVED, topics: response.result });
        } else {
            dispatch({ type: TOPICS_FAILED });
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const fetchAvailableTopicsForCustomer = (customerId: number) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: AVAILABLE_TOPICS_FOR_CUSTOMER_REQUEST });

        const response = await api.topics.getAvailableTopicsForCustomer(customerId);

        if (response.success) {
            dispatch({
                type: AVAILABLE_TOPICS_FOR_CUSTOMER_RECEIVED,
                topics: response.result,
            });
        } else {
            dispatch({ type: TOPICS_FAILED });
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const fetchTopicDetail = (id: number) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        const response = await api.topics.getDetail(id);

        if (response.success) {
            dispatch({ type: TOPIC_DETAIL_RECEIVED, topic: response.result });
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const deleteTopic = (topicId: number) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        const response = await api.topics.deleteTopic(topicId);
        dispatch({ type: TOPIC_DELETED, topicId });

        if (response.success) {
            dispatch(Snackbar.enqueue(PoolNotification.success('app.snackbar.topicDeleted')));
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const updateTopic = (topic: Topic & ObjectWithId) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        const { classifications, ...baseRequest } = topic;
        const request: TopicRequest & ObjectWithId = {
            ...baseRequest,
            classificationIds: classifications.map(c => c.id),
        };
        const response = await api.topics.updateTopic(request);

        if (response.success) {
            dispatch(Snackbar.enqueue(PoolNotification.success('app.snackbar.updated')));
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const createTopic = (topic: Partial<Topic>) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        const { classifications, ...baseRequest } = topic;
        const request: TopicRequest = { ...baseRequest, classificationIds: classifications?.map(c => c.id) };
        const response = await api.topics.createTopic(request);

        if (response.success) {
            dispatch(Snackbar.enqueue(PoolNotification.success('app.snackbar.topicCreated')));
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};
